import * as types from '../mutation-types'
import {setResourceCookie} from "../../utils/resource";

// state
export const state = {
  resource_key: null,
  resource: null,
  parentPage: null,
};

// getters
export const getters = {
  resource_key: state => state.resource_key,
  resource: state => state.resource,
  parentPage: state => state.parentPage,
};

// mutations
export const mutations = {
  [types.UPDATE_RESOURCE_KEY](state, {resource, remember}) {
    state.resource_key = resource;
    setResourceCookie(resource, remember);
  },
  [types.UPDATE_RESOURCE](state, resource) {
    state.resource = resource;
    setResourceCookie(resource, false);
  },
  [types.UPDATE_PARENT_PAGE](state, location) {
    state.parentPage = location;
  },
};

// actions
export const actions = {
  storeResource({commit, dispatch}, payload) {
    commit(types.UPDATE_RESOURCE, payload)
  },
  updateResourceKey({commit, dispatch}, payload) {
    commit(types.UPDATE_RESOURCE_KEY, payload)
  },
  updateParentPage({commit, dispatch}, payload) {
    commit(types.UPDATE_PARENT_PAGE, payload);
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/resource.js